import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)

export default {
  swalDelete() {
    return Vue.swal({
        title: 'Biztos törlöd?',
        text: 'A törlés nem vonható vissza!',
        type: 'danger',
        icon: 'warning',
        iconColor: 'red',
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Törlés',
        cancelButtonText: 'Mégsem',
        confirmButtonClass: 'btn me-5px btn-danger',
        cancelButtonClass: 'btn btn-default',
    })
  },
  swalClose() {
    return Vue.swal({
        title: 'Biztos bezárod?',
        text: 'A bezárással a folyamat megszakad!',
        type: 'danger',
        icon: 'question',
        iconColor: 'orange',
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Bezárás',
        cancelButtonText: 'Mégsem',
        confirmButtonClass: 'btn me-5px btn-orange',
        cancelButtonClass: 'btn btn-default',
    })
  },
  swalCloseOrSaveDraft() {
    return Vue.swal({
        title: 'Biztos bezárod?',
        text: 'A bezárással a folyamat megszakad!',
        type: 'danger',
        icon: 'question',
        iconColor: 'orange',
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Bezárás',
        cancelButtonText: 'Mégsem',
        confirmButtonClass: 'btn me-5px btn-orange',
        cancelButtonClass: 'btn btn-default',
    })
  },
  swalContinue() {
    return Vue.swal({
        title: 'Biztos folytatod?',
        text: 'Befejezetlen műveleted van!',
        type: 'danger',
        icon: 'question',
        iconColor: 'orange',
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Folytatom',
        cancelButtonText: 'Ellenőrzöm',
        confirmButtonClass: 'btn me-5px btn-orange',
        cancelButtonClass: 'btn btn-default',
    })
  },
  swalContinueMessage(message) {
    return Vue.swal({
        title: 'Biztos folytatod?',
        text: message,
        type: 'danger',
        icon: 'question',
        iconColor: 'orange',
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Igen',
        cancelButtonText: 'Nem',
        confirmButtonClass: 'btn me-5px btn-orange',
        cancelButtonClass: 'btn btn-default',
    })
  },
	swalErrorMessage(text) {
		return Vue.swal({
			toast: true,
			position: 'bottom-right',
			iconColor: 'red',
			showConfirmButton: false,
			timer: 3000,
			timerProgressBar: true,
			icon: 'error',
			title: text
		})
	},
	swalCustomConfirm(title,button_text,text) {
    return Vue.swal({
        title: title,
        text: text,
        type: 'danger',
        icon: 'warning',
        iconColor: 'orange',
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: button_text,
        cancelButtonText: 'Mégsem',
        confirmButtonClass: 'btn me-5px btn-orange',
        cancelButtonClass: 'btn btn-default',
    })
  },
  swalEmptyTask() {
		return Vue.swal({
			iconColor: 'red',
			showConfirmButton: false,
			timer: 2500,
			timerProgressBar: true,
			icon: 'error',
			title: 'Üres munkafolyamatot felesleges létrehozni.',
      text:'Lépj vissza és add hozzá a megfelelő elemeket.'
		})
	},
};